import { useCompanyCurrency } from '@packages/core/company/focused-company-context.ts';
import { formatCurrency } from './currency-formatter';

export default function CurrencyView({ price, className, currency }: { className?: string; price: number | null | undefined, currency?: string  }) {
  const defaultCurrency = useCompanyCurrency();

  if (price === null || price === undefined) {
    return <div className={className}>N/A</div>;
  }

  return <span className={className}>{formatCurrency(price, currency ?? defaultCurrency)}</span>;
}
